import React from "react";
import { connect } from "react-redux";

// reactstrap components
import { Row, Col } from "reactstrap";

import * as actions from "../../store/actions/index";

const MethodHeader = (props) => {
  return (
    <>
      <div className="page-header page-header-small">
        <div
          className="page-header-image"
          style={{
            backgroundImage:
              "url(" +
              require("../../assets/img/pexels-pixabay-40751.jpg").default +
              ")",
          }}
        ></div>
        <div className="content-center">
          <Row>
            <Col className="ml-auto mr-auto" md="8">
              <h1 className="title">
                Result capture for {props.selectedEvent.data.name}
              </h1>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
    selectedEvent: state.event.selectedEvent,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetStravaAuthCode: (authCode, refresh_token, tokenExpired) =>
      dispatch(
        actions.getStravaAuthCode(authCode, refresh_token, tokenExpired)
      ),
    onGetStravaActivities: (access_token) =>
      dispatch(actions.getStravaActivities(access_token)),
    onGetStravaAthlete: (access_token) =>
      dispatch(actions.getStravaAthlete(access_token)),
    // onAuthCheckState: () => dispatch(actions.authCheckState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MethodHeader);
